import { Button, TextLink, Tooltip } from '@bfe/moly';
import {
  RefreshIcon,
  BaseIcon,
  // ArrowchevronDownIcon,
  // ArrowchevronUpIcon,
  CheckIcon,
  HelpIcon,
} from '@bfe/moly-icons';
import { useMemo } from 'react';
import { Switch, Case, If, Then, Default } from 'react-if';
import { taskDetail, subTaskListItem, TaskStatus, SubTaskType } from '@/types';
import Link from 'next/link';
import { stringBrChange, stringNbspChange } from '@/utils/common';
import { useFm } from '@web3/base-hooks';
import { isMobile, safeParseJSON } from '@web3/base-utils';
import cls from 'classnames';
import { Page } from '@/config/track-config';
import { useActivityStore } from '@/store/activity';

type ITaskItem = {
  activityId: null | string;
  data: taskDetail;
  activityType: number;
  onActivityApply: (subTask: subTaskListItem) => void;
  handleTaskCheck: (data: taskDetail, isFather: boolean) => void;
};

export function TaskItem(props: ITaskItem) {
  const { activityId, data, activityType } = props;
  const fm = useFm();
  const activityStore = useActivityStore();
  // const exceedLen = 3;
  // 切割 subTaskList
  // const [sliceList] = useState(data.subTaskList?.slice(0, exceedLen));
  // 展开｜收起状态
  // const [unfold, setUnfold] = useState(data.subTaskList?.length > exceedLen);
  //实际渲染 subTaskList
  const renderList = useMemo(() => {
    return data.subTaskList; // unfold ? sliceList : data.subTaskList; unfold, sliceList,
  }, [data.subTaskList]);
  // 展开｜收起
  // const handleFold = () => {
  //   setUnfold(!unfold);
  // };

  const taskRuleConfig = useMemo(() => {
    return safeParseJSON(data.taskRuleConfig, {} as any);
  }, [data]);

  const isShowRefresh = useMemo(() => {
    if (isMobile) return false;
    if (activityType === 4) return false;
    return true;
  }, [activityType]);

  return (
    <div className="task-item-wrap flex-1 p-4 !md:p-8">
      <h4 className="flex justify-between items-center">
        <span className="font-semibold text-sm !md:text-base flex gap-2">
          <span className={cls([isMobile && 'text-gray1'])}>{fm('tasks')}</span>
          {data.taskDesc && (
            <Tooltip
              title={
                <p
                  className="text-sm text-gray1 font-normal "
                  dangerouslySetInnerHTML={{
                    __html: stringNbspChange(
                      stringBrChange(data.taskDesc || '')
                    ),
                  }}
                ></p>
              }
              placement="top"
            >
              <HelpIcon
                className={cls([
                  'text-gray cursor-pointer relative',
                  isMobile ? 'top-[2px] w-4 h-4' : 'top-[3px] hover:opacity-80',
                ])}
              />
            </Tooltip>
          )}
        </span>
        <div>
          {isShowRefresh && (
            <TextLink
              closeIcon={true}
              className="text-xs !md:text-sm mt-2 mr-4"
              color="#adb1b8"
              onClick={() => props.handleTaskCheck(data, true)}
              data-spm-even="Web3UserClick"
              data-spm-data={JSON.stringify({
                page_name: Page.AirdropArcadeDetail,
                button_name: 'Reload',
                Task_index: data.configId,
                activity_index: activityId,
              })}
            >
              <RefreshIcon />
              {fm('refresh')}
            </TextLink>
          )}
          {/* )} */}
          <If condition={taskRuleConfig?.tutorialUrl}>
            <Then>
              <Link target="_blank" href={taskRuleConfig?.tutorialUrl}>
                <TextLink
                  closeIcon={true}
                  className="text-sm mt-2"
                  color="#adb1b8"
                  data-spm-even="Web3UserClick"
                  data-spm-data={JSON.stringify({
                    page_name: Page.AirdropArcadeDetail,
                    button_name: 'Tutorial',
                    Task_index: data.configId,
                    activity_index: activityId,
                  })}
                >
                  <BaseIcon />
                  {fm('tutorial')}
                </TextLink>
              </Link>
            </Then>
          </If>
          <If condition={taskRuleConfig?.swapRankingUrl}>
            <Then>
              <Link target="_blank" href={taskRuleConfig?.swapRankingUrl}>
                <TextLink
                  closeIcon={true}
                  className="text-sm mt-2"
                  color="#adb1b8"
                >
                  <img
                    className="w-4 h-4"
                    src={taskRuleConfig.swapRankingIcon}
                    alt=""
                  />
                  {fm('ranking')}
                </TextLink>
              </Link>
            </Then>
          </If>
        </div>
      </h4>
      {renderList &&
        renderList?.map((task) => (
          <div
            className={cls([
              'flex items-center gap-4 justify-between',
              isMobile ? 'py-4 sub-task-item' : 'bg-card rounded-lg p-4 mt-4 ',
            ])}
            key={task.configId}
          >
            <div>
              <h3 className={cls([isMobile ? 'font-medium' : 'font-semibold'])}>
                {task.taskName}
              </h3>
              <p className="text-sm text-gray1 font-normal mt-2 ">
                {task.taskDesc}
              </p>
            </div>
            <Switch>
              {/* -1用户无法领取到任务 0-任务未完成 1-任务完成，奖励待领取 2-奖励已领取
              3-领取失败 4-奖励达上限，5领取失败-无资格领取，6，分批领取，发放中, 100 任务已结束 */}
              <Case
                condition={
                  (task.taskType === 105 && task.status !== TaskStatus.ended) ||
                  [TaskStatus.unApply, TaskStatus.unComlete].includes(
                    task.status
                  )
                }
              >
                {/* <Link target="_blank" to={task.webGoUrl}> */}
                <Button
                  variant={
                    task.startTime > +new Date()
                      ? 'secondary'
                      : 'secondaryBrand'
                  }
                  className="text-main !w-[144px] "
                  onClick={() => props.onActivityApply(task)}
                  disabled={task.startTime > +new Date()}
                  data-spm-even="Web3UserClick"
                  data-spm-data={JSON.stringify({
                    page_name: Page.AirdropArcadeDetail,
                    button_name: 'Start Now',
                    positionId: data.configId,
                  })}
                >
                  {task.startTime > +new Date()
                    ? fm('status_upcoming')
                    : fm('reward_go')}
                </Button>
                {/* </Link> */}
              </Case>
              <Case condition={task.status === TaskStatus.comleted}>
                <Switch>
                  {/* 社媒 blink 任务 */}
                  <Case condition={task.taskType === SubTaskType.blink}>
                    <Button
                      variant={'secondary'}
                      className="text-white !w-[144px] gap-1"
                      onClick={() => props.onActivityApply(task)}
                      data-spm-even="Web3UserClick"
                      data-spm-data={JSON.stringify({
                        page_name: Page.AirdropArcadeDetail,
                        button_name: 'Post again',
                        positionId: data.configId,
                      })}
                    >
                      <span
                        style={{
                          width: '16px',
                          height: '16px',
                        }}
                      >
                        <CheckIcon
                          style={{
                            color: '#20B26C',
                          }}
                        />
                      </span>
                      {fm('PostAgain')}
                    </Button>
                  </Case>
                  <Default>
                    <Link
                      target="_blank"
                      href={activityStore.taskButtonUrl(task)}
                    >
                      <Button
                        variant={'secondary'}
                        // disabled={task.taskType === 103 ? false : true}
                        className="text-white !w-[97px] gap-1"
                      >
                        <span
                          style={{
                            width: '16px',
                            height: '16px',
                          }}
                        >
                          <CheckIcon
                            style={{
                              color: '#20B26C',
                            }}
                          />
                        </span>
                        {fm('completed')}
                      </Button>
                    </Link>
                  </Default>
                </Switch>
              </Case>
              <Case condition={task.status === TaskStatus.ended}>
                <Switch>
                  {/* 社媒 blink 任务 */}
                  <Case condition={task.taskType === SubTaskType.blink}>
                    <Button
                      variant={'secondary'}
                      className="text-white !w-[144px] gap-1"
                      onClick={() => props.onActivityApply(task)}
                      data-spm-even="Web3UserClick"
                      data-spm-data={JSON.stringify({
                        page_name: Page.AirdropArcadeDetail,
                        button_name: 'Post again',
                        positionId: data.configId,
                      })}
                    >
                      <span
                        style={{
                          width: '16px',
                          height: '16px',
                        }}
                      >
                        <CheckIcon
                          style={{
                            color: '#20B26C',
                          }}
                        />
                      </span>
                      {fm('PostAgain')}
                    </Button>
                  </Case>
                  <Default>
                    <Link
                      target="_blank"
                      href={activityStore.taskButtonUrl(task)}
                    >
                      <Button
                        variant={'secondary'}
                        // disabled={task.taskType === 103 ? false : true}
                        className="text-white !w-[97px] "
                      >
                        {fm('status_ended')}
                      </Button>
                    </Link>
                  </Default>
                </Switch>
              </Case>
            </Switch>
          </div>
        ))}
      {/* {data.subTaskList?.length > exceedLen && (
        <div className="flex justify-center mt-4">
          <Text
            type={'warning'}
            className="flex items-center text-sm cursor-pointer hover:text-[var(--bds-brand-600-hover)]"
            onClick={handleFold}
          >
            {unfold ? (
              <>
                {fm('expand')}

                <ArrowchevronDownIcon />
              </>
            ) : (
              <>
                {fm('collapse')}
                <ArrowchevronUpIcon />
              </>
            )}
          </Text>
        </div>
      )} */}
    </div>
  );
}
